import { createApp } from 'vue'
import { defineAsyncComponent } from 'vue'
// import App from './App.vue'
const App = defineAsyncComponent(() => import('./App.vue'))
import router from './router'
import store from './store'
// util components
import Icono from '../src/utils/Icono.vue'
// const Icono = defineAsyncComponent(() => import('../src/utils/Icono.vue'))
import AppLoading from '../src/utils/AppLoading.vue'
import AppBlockLoading from '../src/utils/AppBlockLoading.vue'
// const AppLoading = defineAsyncComponent(() => import('../src/utils/AppLoading.vue'))
// javascript plugins
import { stringToDate, stringToDateDetail, stringToDateDistance, calculateAge, stringToDateText, stringToDayText, isEqualDates} from './plugins/dates.js'
import { checkCodeCompo } from './plugins/codecheck.js'
import { dsAfterCompile } from './plugins/timeoutFunction.js'
import { isMobile } from './plugins/screenDetected.js'
import { converToPdf } from './plugins/exportPdf.js'

import './preload.js';

const app = createApp(App)

app.component('Icono', Icono)
app.component('app-loading', AppLoading)
app.component('app-block-loading', AppBlockLoading)
// funciones como propiedades globales
app.config.globalProperties.$methods = {
  checkCodeCompo,
  isMobile,
  stringToDate,
  stringToDateDetail,
  stringToDateDistance,
  calculateAge,
  stringToDateText,
  stringToDayText,
  isEqualDates,
  converToPdf,
  dsAfterCompile,
}
//
app.use(store).use(router).mount('#app')
